import useOverlayBadge from "@insite/client-framework/Common/Hooks/useOverlayBadge";
import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
// import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles"; // Poolcorp Custom Code
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import sendProductRecommendationTracking from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/SendProductRecommendationTracking";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
// import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage"; // Poolcorp Custom Code
// import ProductImageBadges from "@insite/content-library/Components/ProductImageBadges"; // Poolcorp Custom Code
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
// import ProductPrice from "@insite/content-library/Components/ProductPrice"; // Poolcorp Custom Code
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
// import ProductTextBadges from "@insite/content-library/Components/ProductTextBadges"; // Poolcorp Custom Code
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import Badge from "@insite/mobius/Badge";
import { ButtonPresentationProps } from "@insite/mobius/Button";
// import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer"; // Poolcorp Custom Code
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Poolcorp Custom Code */
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { ProductAvailabilityStyles } from "@store/Overrides/Components/ProductAvailability";
import ProductContextAvailability from "@store/Overrides/Components/ProductContextAvailability";
import ProductImage, { ProductImageStyles, productImageStyles } from "@store/Overrides/Components/ProductImage";
import ProductPrice, { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { contentSpacingStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import getBooleanProperty from "@store/utilities/getBooleanProperty";
/* Poolcorp Custom Code */

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    productInfo: getProductInfoFromList(state, ownProps.carouselId, ownProps.product.id),
    // Poolcorp Custom Code
    isSignedIn: state.context.session.userName && !getCurrentUserIsGuest(state),
    rememberMe: state.context.session.rememberMe,
});

const mapDispatchToProps = {
    updateProductInfo,
    sendProductRecommendationTracking,
};

interface OwnProps {
    carouselId: string;
    product: ProductModel;
    recommendationId?: number;
    showImage: boolean;
    showBrand: boolean;
    showTitle: boolean;
    showPartNumbers: boolean;
    showPrice: boolean;
    showAddToCart: boolean;
    showAddToList: boolean;
    showImageBadges?: boolean;
    maximumNumberOfImageBadges?: number;
    showTextBadges?: boolean;
    maximumNumberOfTextBadges?: number;
    extendedStyles?: ProductCarouselProductStyles;
    // Poolcorp Custom Code
    showAvailability: boolean;
}

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface ProductCarouselProductStyles {
    productImageStyles?: ProductImageStyles;
    productBrandWrapper?: InjectableCss;
    productBrandStyles?: ProductBrandStyles;
    productDescriptionStyles?: ProductDescriptionStyles;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    productPriceWrapper?: InjectableCss;
    productUnitOfMeasureSelectStyles?: SelectPresentationProps;
    productQuantityBreakPricingStyles?: ProductQuantityBreakPricingStyles;
    addToCartContainer?: GridContainerProps;
    qtyGridItem?: GridItemProps;
    productQuantityOrderedStyles?: TextFieldProps;
    addToCartButtonGridItem?: GridItemProps;
    productAddToCartButtonStyles?: ButtonPresentationProps;
    productAddToListLinkStyles?: ProductAddToListLinkStyles;
    badgeAreaWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    badgeImageWrapper?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    badgeImageProps?: JSX.IntrinsicElements["img"];
    /* Poolcorp Custom Code */
    productAvailabilityWrapper?: InjectableCss;
    productAvailability?: ProductAvailabilityStyles;
    addToCartWrapper?: InjectableCss;
    addToListWrapper?: InjectableCss;
    productPrice?: ProductPriceStyles;
    bottomWrapper?: InjectableCss;
}

export const productCarouselProductStyles: ProductCarouselProductStyles = {
    productImageStyles: {
        wrapper: {
            css: css`
                ${productImageStyles.wrapper?.css}
                ${contentSpacingStyles()}
            `,
        },
        img: {
            css: css`
                margin: 0 auto;
            `,
        },
    },
    productBrandWrapper: {
        css: css`
            ${contentSpacingStyles(null, ".5em")}
        `,
    },
    productDescriptionStyles: {
        productDetailLink: {
            css: css`
                margin-bottom: 0.5em;
                text-align: center;
                color: ${getColor("text")};
                font-weight: ${TYPOGRAPHY.weight.black};
                line-height: ${TYPOGRAPHY.lineHeight.small};
                text-decoration: none;

                &:hover,
                &:active,
                &:visited {
                    color: ${getColor("text")};
                }

                &:hover {
                    text-decoration: underline;
                }
            `,
        },
    },
    productPartNumbersStyles: {
        container: {
            css: css`
                ${contentSpacingStyles(null, ".5em")}
                font-size: ${TYPOGRAPHY.size.smallest};
                flex-grow: 0;
            `,
        },
        erpNumberGridItem: {
            css: css`
                justify-content: center;
            `,
        },
        customerNameGridItem: {
            css: css`
                justify-content: center;
            `,
        },
        manufacturerItemGridItem: {
            css: css`
                justify-content: center;
            `,
        },
    },
    productPriceWrapper: {
        css: css`
            ${contentSpacingStyles(null, "1em")}
            text-align: center;
        `,
    },
    productUnitOfMeasureSelectStyles: {
        cssOverrides: {
            formField: css`
                margin-bottom: 6px;
                align-items: center;
            `,
            formInputWrapper: css`
                max-width: 100px;
            `,
            inputSelect: css`
                width: 100%;
            `,
        },
    },
    addToCartContainer: {},
    qtyGridItem: {},
    addToCartButtonGridItem: {},
    productAddToCartButtonStyles: {},
    productAddToListLinkStyles: {
        link: {
            typographyProps: {},
            css: css`
                ${({ theme }) => theme?.link?.defaultProps?.css}
                font-weight: ${TYPOGRAPHY.weight.black};
                font-size: ${TYPOGRAPHY.size.smaller};
            `,
        },
    },
    productAvailabilityWrapper: {
        css: css`
            text-align: center;
            ${contentSpacingStyles(null, "1em")}
        `,
    },
    productAvailability: {
        inventoryMessage: {
            css: css`
                display: flex;
                justify-content: center;
            `,
        },
    },
    addToCartWrapper: {
        css: css`
            display: flex;
            justify-content: center;
        `,
    },
    addToListWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            ${contentSpacingStyles("0.5em", null)}
        `,
    },
    productPrice: {
        priceWrapper: {
            css: css`
                text-align: center;
            `,
        },
        priceLabelText: {
            variant: "legend",
            css: css`
                text-align: center;
            `,
        },
    },
    bottomWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            justify-content: flex-end;
            ${contentSpacingStyles("1em", null)}
        `,
    },
};

const ProductCarouselProduct = ({
    carouselId,
    product,
    showImage,
    showBrand,
    showTitle,
    showPartNumbers,
    showPrice,
    showAddToCart,
    showAddToList,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
    updateProductInfo,
    extendedStyles,
    productInfo,
    recommendationId,
    sendProductRecommendationTracking,
    // Poolcorp Custom Code
    showAvailability,
    isSignedIn,
    rememberMe,
}: Props) => {
    const [styles] = useState(() => mergeToNew(productCarouselProductStyles, extendedStyles));

    const updateQuantity = (qtyOrdered: number) => {
        updateProductInfo({ id: carouselId, productId: product.id, qtyOrdered });
    };

    const updateUnitOfMeasure = (unitOfMeasure: string) => {
        updateProductInfo({ id: carouselId, productId: product.id, unitOfMeasure });
    };

    if (!product || !productInfo) {
        return null;
    }

    const productContext = {
        product,
        productInfo,
        onUnitOfMeasureChanged: updateUnitOfMeasure,
        onQtyOrderedChanged: updateQuantity,
    };

    const trackProductRecommendation = (isNewPageWasOpen: boolean) => {
        if (recommendationId) {
            sendProductRecommendationTracking({ recommendationId, isNewPageWasOpen });
        }
    };

    const {
        showOverlayBadge,
        overlayBadge,
        overlayBadgeWrapperStyles,
        badgeAreaWrapperRef,
        overlayBadgeWrapperClickHandler,
    } = useOverlayBadge({
        productContext,
        showTextBadge: showTextBadges,
        showImageBadge: showImageBadges,
        styles,
    });

    const { imageBadges, textBadges } = useWidgetBadges({ productContext, showTextBadges, showImageBadges });

    return (
        <>
            <ProductContext.Provider value={productContext}>
                {/* Poolcorp Custom Code */}
                {showImage && (
                    <ProductImage
                        product={productContext}
                        onClick={() => trackProductRecommendation(true)}
                        extendedStyles={styles.productImageStyles}
                    />
                )}
                {showTitle && (
                    <ProductDescription
                        product={productContext}
                        onClick={() => trackProductRecommendation(true)}
                        extendedStyles={styles.productDescriptionStyles}
                    />
                )}
                {/* Poolcorp Custom Code */}
                {/* Poolcorp Custom Code - badges removed */}
                {/* Poolcorp Custom Code - shop brand removed */}
                {showPartNumbers && (
                    <ProductPartNumbers
                        productNumber={product.productNumber}
                        customerProductNumber={product.customerProductNumber}
                        manufacturerItem={product.manufacturerItem}
                        showCustomerName={false}
                        showManufacturerItem={false}
                        extendedStyles={styles.productPartNumbersStyles}
                    />
                )}
                {/* Poolcorp Custom Code */}
                {(isSignedIn || rememberMe) && (showAvailability || showPrice || showAddToCart || showAddToList) ? (
                    <StyledWrapper {...styles.bottomWrapper}>
                        {showAvailability && (
                            <StyledWrapper {...styles.productAvailabilityWrapper}>
                                <ProductContextAvailability 
                                    extendedStyles={styles.productAvailability}
                                    isCondensed={false}
                                    qtyOrdered={productContext.productInfo.qtyOrdered}
                                />
                            </StyledWrapper>
                        )}
                        {showPrice && (
                            <StyledWrapper {...styles.productPriceWrapper}>
                                <ProductPrice
                                    showLabel={false}
                                    product={productContext}
                                    extendedStyles={styles.productPrice}
                                />
                                <ProductQuantityBreakPricing
                                    extendedStyles={styles.productQuantityBreakPricingStyles}
                                />
                            </StyledWrapper>
                        )}
                        {product.unitOfMeasures && (
                            <>
                                <VisuallyHidden as="label" htmlFor={`${carouselId}-uom`} id={`${carouselId}-uom-label`}>
                                    {translate("U/M")}
                                </VisuallyHidden>
                                <ProductUnitOfMeasureSelect
                                    labelOverride=""
                                    extendedStyles={styles.productUnitOfMeasureSelectStyles}
                                    id={`${carouselId}-uom`}
                                />
                            </>
                        )}
                        {showAddToCart && (
                            <StyledWrapper {...styles.addToCartWrapper}>
                                <VisuallyHidden as="label" htmlFor={`${carouselId}-qty`} id={`${carouselId}-qty-label`}>
                                    {translate("QTY")}
                                </VisuallyHidden>
                                <ProductQuantityOrdered
                                    labelOverride=""
                                    extendedStyles={styles.productQuantityOrderedStyles}
                                    id={`${carouselId}-qty`}
                                />
                                <ProductAddToCartButton
                                    onAddToCartClick={() => trackProductRecommendation(false)}
                                    data-test-selector="addToCartBtn"
                                    extendedStyles={styles.productAddToCartButtonStyles}
                                    labelOverride={translate("Add")}
                                />
                            </StyledWrapper>
                        )}
                        {showAddToList && (
                            <StyledWrapper {...styles.addToListWrapper}>
                                <ProductAddToListLink
                                    data-test-selector="addToListLink"
                                    extendedStyles={styles.productAddToListLinkStyles}
                                />
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                ) : null}
                {/* Poolcorp Custom Code */}
            </ProductContext.Provider>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductCarouselProduct);
